import React, { useContext, useEffect, useState } from 'react';
import '../../../assests/css/admin/UserManagement/StudentManagement.css';
import {
  Search,
  Plus,
  CheckCircle,
  XCircle,
  RefreshCw,
  Users,
  X,
  User,
  Mail,
  BookOpen,
} from 'lucide-react';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';
import { AppContext } from '../../../context/Appcontext';
import axios from 'axios';

const StudentManagement = () => {
  const { baseUrl } = useContext(AppContext);

  /* ── State ── */
  const [students, setStudents]       = useState([]);
  const [searchTerm, setSearchTerm]   = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  /* ── Form fields ── */
  const [fullname, setFullName] = useState('');
  const [email, setEmail]       = useState('');
   const [Programme, setProgramme]       = useState('');
    const [semester, setSemester]       = useState('');
       const [rollNo, setRollNO]       = useState('');
  const [session, setSession]       = useState('');

  /* ── API: fetch all students ── */
  const viewAllStudents = () => {
    axios
      .get(`${baseUrl}/admin/usermanagement/viewAllStudents`)
      .then((res) => setStudents(res.data.students))
      .catch((err) => console.log(err));
  };

  /* ── API: add student ── */
  const addStudent = () => {
    const formData = new FormData();
    formData.append('fullname', fullname);
    formData.append('email', email);
      formData.append('programme', Programme);
        formData.append('semester', semester);
            formData.append('rollNo', rollNo);
    formData.append('session', session);

    axios
      .post(`${baseUrl}/admin/usermanagement/addStudents`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => {
        console.log(res.data);
        resetForm();
        setIsModalOpen(false);
        viewAllStudents();
      })
      .catch((err) => console.log(err));
  };

  /* ── Helpers ── */
  const resetForm = () => {
    setFullName('');
    setEmail('');
     setProgramme('');
      setSemester('');
       setRollNO('');
    setSession('');
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addStudent();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) handleModalClose();
  };

  /* ── Search filter (no status filter) ── */
  const displayedStudents = students.filter((s) => {
    const term = searchTerm.toLowerCase();
    return (
      s.fullname?.toLowerCase().includes(term) ||
      s.email?.toLowerCase().includes(term)
    );
  });

  useEffect(() => {
    viewAllStudents();
  }, []);

  /* ── Render ── */
  return (
    <Adminmasterlayout>
      <div className="sm">
        <div className="sm__container">

          {/* ── Header ── */}
          <div className="sm__header">
            <div className="sm__header-content">
              <div className="sm__header-icon">
                <Users size={32} />
              </div>
              <div>
                <h1 className="sm__header-title">Student Management</h1>
                <p className="sm__header-subtitle">Manage and monitor all students</p>
              </div>
            </div>
            <button className="sm__header-btn" onClick={() => setIsModalOpen(true)}>
              <Plus size={20} />
              Add New Student
            </button>
          </div>

          {/* ── Toolbar ── */}
          <div className="sm__toolbar">
            <div className="sm__search">
              <Search size={20} className="sm__search-icon" />
              <input
                type="text"
                placeholder="Search by name or email address..."
                className="sm__search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* ── Table ── */}
          <div className="sm__content">
            <div className="sm-table__wrapper">
              <table className="sm-table">
                <thead className="sm-table__head">
                  <tr className="sm-table__row">
                    <th className="sm-table__header">#</th>
                    <th className="sm-table__header">Name</th>
                    <th className="sm-table__header">Email</th>
                    <th className="sm-table__header">Session</th>
                      <th className="sm-table__header">Programme</th>
                        <th className="sm-table__header">Semester</th>
                          <th className="sm-table__header">Roll No</th>
                    <th className="sm-table__header">Enrolled</th>
                    <th className="sm-table__header sm-table__header--actions">Actions</th>
                  </tr>
                </thead>
                <tbody className="sm-table__body">
                  {displayedStudents.length > 0 ? (
                    displayedStudents.map((student, index) => (
                      <tr key={student.id || index} className="sm-table__row">
                        <td className="sm-table__cell sm-table__cell--index">{index + 1}</td>
                        <td className="sm-table__cell">
                          <div className="sm-table__user">
                            <div className="sm-table__avatar">
                              {student.fullname?.charAt(0).toUpperCase()}
                            </div>
                            <span className="sm-table__name">{student.fullname}</span>
                          </div>
                        </td>
                        <td className="sm-table__cell sm-table__cell--email">{student.email}</td>
                        <td className="sm-table__cell">{student.session}</td>
                        <td className="sm-table__cell">
                          {student.created_at
                            ? new Date(student.created_at).toLocaleDateString()
                            : '—'}
                        </td>
                        <td className="sm-table__cell sm-table__cell--actions">
                          <div className="sm-table__actions">
                            <button
                              className="sm-table__action-btn sm-table__action-btn--approve"
                              title="Approve"
                            >
                              <CheckCircle size={16} />
                            </button>
                            <button
                              className="sm-table__action-btn sm-table__action-btn--reject"
                              title="Reject"
                            >
                              <XCircle size={16} />
                            </button>
                            <button
                              className="sm-table__action-btn sm-table__action-btn--reset"
                              title="Reset"
                            >
                              <RefreshCw size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="sm-table__row">
                      <td className="sm-table__cell sm-table__cell--empty" colSpan="6">
                        No students found matching your criteria
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      {/* ── Add Student Modal ── */}
      {isModalOpen && (
        <div className="sm-modal__overlay" onClick={handleOverlayClick}>
          <div className="sm-modal">

            {/* Modal Header */}
            <div className="sm-modal__header">
              <div className="sm-modal__header-left">
                <div className="sm-modal__header-icon">
                  <User size={22} />
                </div>
                <div>
                  <h2 className="sm-modal__title">Add New Student</h2>
                  <p className="sm-modal__header-subtitle">
                    Fill in the details to register a student
                  </p>
                </div>
              </div>
              <button
                className="sm-modal__close"
                onClick={handleModalClose}
                aria-label="Close modal"
              >
                <X size={18} />
              </button>
            </div>

            {/* Modal Form */}
            <form onSubmit={handleSubmit}>
              <div className="sm-modal__body">
                <div className="sm-modal__form">

                  {/* Full Name */}
                  <div className="sm-modal__form-group">
                    <label
                      className="sm-modal__form-label sm-modal__form-label--icon"
                      htmlFor="sm-fullname"
                    >
                      <User size={14} />
                      Full Name
                    </label>
                    <input
                      id="sm-fullname"
                      type="text"
                      className="sm-modal__form-input"
                      placeholder="e.g. Ahmad Hassan"
                      value={fullname}
                      onChange={(e) => setFullName(e.target.value)}
                      required
                    />
                  </div>

                  {/* Email */}
                  <div className="sm-modal__form-group">
                    <label
                      className="sm-modal__form-label sm-modal__form-label--icon"
                      htmlFor="sm-email"
                    >
                      <Mail size={14} />
                      Email Address
                    </label>
                    <input
                      id="sm-email"
                      type="email"
                      className="sm-modal__form-input"
                      placeholder="e.g. ahmad@school.edu"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="sm-modal__form-group">
                    <label
                      className="sm-modal__form-label sm-modal__form-label--icon"
                      htmlFor="sm-programme"
                    >
                      <Mail size={14} />
                      Programme
                    </label>
                    <input
                      id="sm-programme"
                      type="text"
                      className="sm-modal__form-input"
                      placeholder="Programme"
                      value={Programme}
                      onChange={(e) => setProgramme(e.target.value)}
                      required
                    />
                  </div>
                  <div className="sm-modal__form-group">
                    <label
                      className="sm-modal__form-label sm-modal__form-label--icon"
                      htmlFor="sm-semester"
                    >
                      <Mail size={14} />
                      Semester
                    </label>
                    <input
                      id="sm-semester"
                      type="text"
                      className="sm-modal__form-input"
                      placeholder="Semester"
                      value={semester}
                      onChange={(e) => setSemester(e.target.value)}
                      required
                    />
                  </div>
                  <div className="sm-modal__form-group">
                    <label
                      className="sm-modal__form-label sm-modal__form-label--icon"
                      htmlFor="sm-rollNo"
                    >
                      <Mail size={14} />
                      Roll No
                    </label>
                    <input
                      id="sm-rollNo"
                      type="text"
                      className="sm-modal__form-input"
                      placeholder="Roll No"
                      value={rollNo}
                      onChange={(e) => setRollNO(e.target.value)}
                      required
                    />
                  </div>

                  {/* session — full width */}
                  <div className="sm-modal__form-group sm-modal__form-group--full">
                    <label
                      className="sm-modal__form-label sm-modal__form-label--icon"
                      htmlFor="sm-session"
                    >
                      <BookOpen size={14} />
                      Session
                    </label>
                    <input
                      id="sm-session"
                      type="text"
                      className="sm-modal__form-input"
                      placeholder="session"
                      value={session}
                      onChange={(e) => setSession(e.target.value)}
                      required
                    />
                  </div>

                </div>
              </div>
                   

              {/* Modal Footer */}
              <div className="sm-modal__footer">
                <button
                  type="button"
                  className="sm-modal__btn sm-modal__btn--cancel"
                  onClick={handleModalClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="sm-modal__btn sm-modal__btn--save"
                >
                  Save Student
                </button>
              </div>
            </form>

          </div>
        </div>
      )}

    </Adminmasterlayout>
  );
};

export default StudentManagement;